import styled from 'styled-components';
import { AnimationTypes, Animations } from '../Animations';

export type AnimationSpanProps = {
    $animation: AnimationTypes;
    $duration?: number;
    $iterations?: number;
    $loop?: boolean;
};

export const AnimationSpan = styled.span<AnimationSpanProps>`
    display: inline-flex;

    animation-name: ${props => Animations[props.$animation].keyframes};
    animation-duration: ${props => Animations[props.$animation].duration ?? 1000}ms;
    animation-iteration-count: ${props =>
        Animations[props.$animation].loop || props.$loop
            ? 'infinite'
            : (Animations[props.$animation].iterations ?? props.$iterations ?? 1)};
`;
AnimationSpan.displayName = 'AnimationSpan';
